import Vue from 'vue'
import Router from 'vue-router'
import beforeEach from './beforeEach'

Vue.use(Router)

import routes from '../app/rotas'
 

const router = new Router({routes})

router.beforeEach(beforeEach)

export default router